/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LinkDto } from '../models/LinkDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DataUploadsService {
    /**
     * @param code
     * @returns LinkDto OK
     * @throws ApiError
     */
    public static getApiDataUploads(
        code: string,
    ): CancelablePromise<LinkDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/DataUploads/{code}',
            path: {
                'code': code,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
